export default class LandingPageService {
  constructor(apiService) {
    this.apiService = apiService
  }

  getEntity(id, params) {
    return this.apiService.callGet('landingPage', params)
  }

  updateEntity(id, params) {
    return this.apiService.callPut('landingPage', params)
  }

  deleteEntity(id, params) {
    return this.apiService.callDelete('landingPage', params)
  }
}



// WEBPACK FOOTER //
// ./src/service/LandingPageService.js